import React from 'react';
const contents = [{
  emoji: '📅',
  title: '5 Tomos Anuales',
  desc: '52 semanas de clases planificadas'
}, {
  emoji: '🌿',
  title: 'Yoga Terapéutico',
  desc: '25 protocolos para dolencias reales'
}, {
  emoji: '🪷',
  title: 'Filosofía y Temas',
  desc: '52 temas para elevar cada clase'
}, {
  emoji: '📖',
  title: 'Biblioteca de Asanas',
  desc: '200+ posturas con cues verbales'
}];
const finalContent = {
  emoji: '💼',
  title: 'El Negocio del Yoga',
  desc: 'Vivir del yoga en LATAM'
};
export function BenefitsSection() {
  return <section className="w-full bg-bg-alt py-16 sm:py-24 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <div className="text-center mb-12 sm:mb-16" data-id="element-3">
          <h2 className="text-3xl sm:text-5xl font-serif font-black text-text-main" data-id="element-4">
            📦 ¿Qué contiene el Kit Yoga Lista?
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-4 sm:mb-6" data-id="element-5">
          {contents.map((item, i) => <div key={i} className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm" data-id="element-6">
              <div className="text-4xl sm:text-5xl mb-4" data-id="element-7">{item.emoji}</div>
              <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-8">
                {item.title}
              </h3>
              <p className="text-text-sec text-base" data-id="element-9">{item.desc}</p>
            </div>)}
        </div>

        {/* Centered final card */}
        <div className="max-w-md mx-auto" data-id="element-10">
          <div className="bg-bg-main rounded-3xl p-6 sm:p-8 border border-border-light flex flex-col items-center text-center shadow-sm" data-id="element-11">
            <div className="text-4xl sm:text-5xl mb-4" data-id="element-12">
              {finalContent.emoji}
            </div>
            <h3 className="text-xl sm:text-2xl font-bold text-text-main mb-2" data-id="element-13">
              {finalContent.title}
            </h3>
            <p className="text-text-sec text-base" data-id="element-14">{finalContent.desc}</p>
          </div>
        </div>
      </div>
    </section>;
}